<template>
  <div>
    <div v-if="efectorlogueado">
      <v-tabs v-model="tab" background-color="light-blue accent-1">
        <v-tab>Buscar Autorizaciones</v-tab>
        <v-tab>Últimas Autorizaciones</v-tab>
        <v-tab v-if="true">Nueva Autorización</v-tab>
        <v-tab-item>
          <v-row>
            <v-col>
              <v-card color="teal">
                <v-card-title>
                  Buscar
                  <v-spacer></v-spacer>
                  <v-text-field
                    hide-details
                    placeholder=""
                    outlined
                    dense
                    v-model.number="id_solicbuscar"
                    label="Nro.de Autorizacion"
                    append-icon="mdi-magnify"
                    @click:append="BuscarSolic"
                    @keydown.enter.prevent="BuscarSolic"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <autocompletar v-model="afibuscado"></autocompletar>
                  <v-spacer></v-spacer>
                </v-card-title>
              </v-card>
            </v-col>
            <v-col md="12" v-if="condicionesafibuscado != ''">
              <h3>{{ condicionesafibuscado }}</h3>
            </v-col>
            <v-col md="12">
              <lista
                vertodas
                :items="ListaPorAfiliado"
                v-if="
                  !solicbuscada &&
                    ListaPorAfiliado.length > 0 &&
                    !id_solicbuscado
                "
                v-model="solicbuscada"
              ></lista>
            </v-col>
            <v-col md="12">
              <Confirmar
                @exit="
                  solicbuscada = null;
                  id_solicbuscado = null;
                "
                :id_efector="efectorlogueado.Id"
                :id_solic="id_solicbuscado"
              ></Confirmar>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col md="12">
              <h3>Últimas Autorizaciones</h3>
            </v-col>
            <v-col md="12">
              <lista
                vertodas
                :items="ListaPorEfector"
                v-if="!selected"
                v-model="selected"
              ></lista>
            </v-col>
            <v-col md="12">
              <Modificar
                readonly
                v-if="selected"
                :solic="selected"
                :idsolic="selected.id_solic"
                @guardado="selected = undefined"
              ></Modificar>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item v-if="true">
          <v-row dense no-gutters>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  Buscar
                  <v-spacer></v-spacer>
                  <autocompletar v-model="buscado"></autocompletar>
                  <v-spacer></v-spacer>
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
          <v-row dense no-gutters v-if="buscado">
            <v-col md="12" v-if="condicionesbuscado != ''">
              <h3>{{ condicionesbuscado }}</h3>
            </v-col>
            <v-col md="12" v-if="condicionesbuscado == ''">
              <Administrar
                titulo="Consulta de datos"
                readonly
                micrositio
                :efectorlogueado="efectorlogueado"
                v-if="Seleccionado && Seleccionado.id_afiliado != 0"
              ></Administrar>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import Administrar from "@/components/Beneficiarios/Administrar.vue";
import autocompletar from "@/components/Beneficiarios/AutoNombreDNINroAfi";
import lista from "@/components/Practica/Lista";
import Modificar from "@/components/Practica/Modificar";
import Confirmar from "@/components/Practica/ConfirmarPorEfector";
import LUM from "@/lib/LUM";
import API from "@/lib/API";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    Administrar,
    autocompletar,
    Confirmar,
    lista,
    Modificar,
  },
  data() {
    return {
      tab: 0,
      buscado: undefined,
      afibuscado: undefined,
      selected: undefined,
      id_solicbuscado: undefined,
      id_solicbuscar: undefined,
      solicbuscada: undefined,
      ListaPorAfiliado: [],
    };
  },
  computed: {
    ...mapState("micrositioefectores", ["Usuario"]),
    ...mapState("efectores", { efectorlogueado: "Seleccionado" }),
    ...mapState("beneficiarios", ["Lista", "Seleccionado"]),
    ...mapState("autorizaciones", ["ListaPorEfector"]),
    condicionesbuscado() {
      return this.condicionesbeneficiario(this.buscado);
    },
    condicionesafibuscado() {
      return this.condicionesbeneficiario(this.afibuscado);
    },
    hoy() {
      return LUM.datetoYYYYMMDD(new Date());
    },
  },
  methods: {
    ...mapActions("beneficiarios", ["select"]),
    ...mapActions("autorizaciones", ["traerPorEfector"]),
    ...mapActions("efectores", { SeleccionarEfector: "select" }),
    ...mapActions("micrositioefectores", ["inicializar"]),

    condicionesbeneficiario(beneficiario) {
      let ret = "";
      if (this.efectorlogueado) {
        if (beneficiario) {
          if (beneficiario.id_plan) {
            if (
              this.efectorlogueado.Efector_Plan.findIndex(
                (x) => x.Id_Plan == beneficiario.id_plan
              ) < 0
            ) {
              ret = "* El beneficiario NO corresponde al plan";
            }
          } else {
            ret += "* Afiliado sin plan";
          }
          if (beneficiario.fecha_fin_cobertura < this.hoy) {
            ret +=
              "* Afiliado sin cobertura desde el " +
              LUM.datetoDDMMYYYY(beneficiario.fecha_fin_cobertura);
          }
        }
      }
      return ret;
    },
    traer() {
      this.traerPorEfector(this.efectorlogueado.Id);
    },
    BuscarSolic() {
      this.id_solicbuscado = this.id_solicbuscar;
    },
  },
  watch: {
    buscado() {
      this.select(this.buscado);
    },
    solicbuscada() {
      if (this.solicbuscada) {
        this.id_solicbuscado = this.solicbuscada.id_solic;
      } else {
        // this.id_solicbuscado = null;
      }
    },
    async afibuscado() {
      if (this.afibuscado) {
        this.id_solicbuscado = undefined;
        this.ListaPorAfiliado = await API.Autorizaciones.traerPorAfiliadoyEfector(
          this.afibuscado.id_afiliado,
          this.efectorlogueado.Id
        );
      }
    },
    efectorlogueado() {
      if (this.efectorlogueado) {
        this.traerPorEfector(this.efectorlogueado.Id);
        this.$msjpusher.$on(
          "practicaGuardada_" + this.efectorlogueado.Id,
          this.traer
        );
      }
    },
  },
  async mounted() {
    if (!this.Usuario) {
      await this.inicializar();
      if (!this.Usuario) {
        this.$router.push({ name: "Micrositio" });
      }
    }
    if (this.Usuario && !this.efectorlogueado) {
      let efector = await API.Efector.traerUno(this.Usuario.UserId);
      this.SeleccionarEfector(efector);
    }
    if (this.efectorlogueado) {
      this.traerPorEfector(this.efectorlogueado.Id);
      this.$msjpusher.$on(
        "practicaGuardada_" + this.efectorlogueado.Id,
        this.traer
      );
    }
  },
};
</script>

<style></style>
